import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AnnotationStoreService {
  public annotations$: BehaviorSubject<any> = new BehaviorSubject([]);
  public annotationsGallery$: BehaviorSubject<any> = new BehaviorSubject([]);

  set setAnnotations(data) {
    this.annotationsGallery$.next(data.filter(d => {
      try {
        const area = JSON.parse(d.area);
        return (area.length > 0 && area[0].hasOwnProperty('className') && area[0].hasOwnProperty('attrs'))
      } catch (error) {
        console.log(d)
      }
    }))
    this.annotations$.next(data)
  }

  set appendAnnotation(data){
    const oldData = this.annotations$.getValue().filter(annot => annot.id !== data.id)
    oldData.push(data)
    this.setAnnotations = oldData
  }

  clearDataService() {
    this.annotations$ = new BehaviorSubject({});

  }

  constructor() { }
}
